import { CurrentAction } from "./customer-compliance.model";

export abstract class KycMessageService {
	abstract showMessage(status: CurrentAction): void;
}

export class NoopKycMessageService implements KycMessageService {
	showMessage(_status: CurrentAction) {
		// noop
	}
}
